const error = function (msg) {
  let wrap = document.createElement('div')
  wrap.className = 'app-error'
  wrap.innerHTML = `<div class="error-content"><div class="error-title">提示</div><div class="error-msg">${msg}</div></div>`
  document.body.appendChild(wrap)
}

var tips = function (msg, type, delay) {
  let timer = null
  let wrap = document.createElement('div')
  wrap.innerHTML = `<div class="tips-msg"></div>`
  wrap.style.display = 'none'
  document.body.appendChild(wrap)

  let showTips = (msg, type, delay) => {
    timer && (timer = clearTimeout(timer))
    type = type || 'info'
    delay = delay || 3000
    wrap.className = 'app-tips ' + type
    wrap.querySelector('.tips-msg').innerHTML = msg
    // 显示
    wrap.style.display = 'block'
    if (delay !== true) {
      timer = setTimeout(() => {
        wrap.style.display = 'none'
      }, delay)
    }
  }
  showTips(msg, type, delay)
  tips = showTips
}

const Methods = {
  install(Vue, options) {
    Vue.prototype.$success = (msg, delay) => {
      tips(msg, 'success', delay)
    }

    Vue.prototype.$warning = (msg, delay) => {
      tips(msg, 'warning', delay)
    }

    Vue.prototype.$info = (msg, delay) => {
      tips(msg, 'info', delay)
    }
    Vue.prototype.$tipsContent = (msg, delay) => {
      tips(msg, 'content', delay)
    }

    Vue.prototype.$error = error
  }
}

export default Methods



// WEBPACK FOOTER //
// ./src/plugins/methods.js